import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=75cdd9e2&scoped=true"
import script from "./wxlogin.vue?vue&type=script&lang=js"
export * from "./wxlogin.vue?vue&type=script&lang=js"
import style0 from "./wxlogin.vue?vue&type=style&index=0&id=75cdd9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cdd9e2",
  null
  
)

export default component.exports